import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUser } from "../../Localstorage/localstorage";
import MailboxKlant from "./MailboxKlant";
import MailboxAdmin from "./MailboxAdmin";
import MailList from "./MailList";
import RPDrawerMessaging from "../../Componenten/Drawers/RPDrawerMessaging";
import { setCommand } from "../../redux/mailSlice";
import { IOSOCKETCLIENT, setIOSocketListeners } from "../../linksocket/linksocket";
import { MAKE_SOCKET_CHANNEL, SOCKET_CHANNELS } from "../../constants/constants";
import { fetchMailMessages, fetchMailRooms } from "../../apiCalls/messageApi";
import { wa } from "./mailWaTheme";

const MailBox = () => {
  const user = getUser();
  const [openDialog, setOpenDialog] = useState(false);
  const [mobileChatOpen, setMobileChatOpen] = useState(false);
  const dispatch = useDispatch();
  const { mailMessage } = useSelector((state) => state.mail);

  const getMail = useCallback(async () => {
    await Promise.all([
      fetchMailRooms(user, dispatch, mailMessage, 8, 0, ""),
      fetchMailMessages(user, dispatch),
    ]);
  }, [dispatch, user?.id]);

  const refreshMail = useCallback(
    (test = null) => {
      fetchMailRooms(user, dispatch, test || mailMessage, 8, 0, "");
      fetchMailMessages(user, dispatch);
    },
    [user, dispatch, mailMessage]
  );

  useLayoutEffect(() => {
    if (user?.id) {
      getMail();
    }
  }, [user?.id, getMail]);

  const prevChannelRef = useRef();

  useEffect(() => {
    if (user?.id && mailMessage?.id) {
      const channel = MAKE_SOCKET_CHANNEL(mailMessage?.id, SOCKET_CHANNELS.MAIL_ITEM);

      if (prevChannelRef.current === channel) return;

      setIOSocketListeners(channel, SOCKET_CHANNELS.MAIL_ITEM, refreshMail);
      return () => {
        IOSOCKETCLIENT.emit("JOINLEAVEROOM", { action: "leave", channel });
      };
    }
  }, [user, mailMessage?.id, refreshMail]);

  const openModal = (p_type = "insert") => {
    dispatch(setCommand(p_type));
    setOpenDialog(true);
  };

  const handleConversationOpen = (fromUserClick) => {
    if (fromUserClick) setMobileChatOpen(true);
  };

  const handleExitMobileChat = () => {
    setMobileChatOpen(false);
  };

  return (
    <div className={`flex h-full min-h-0 w-full flex-1 flex-col ${wa.app}`}>
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <main className="flex min-h-0 min-w-0 flex-1 flex-col md:flex-row">
          {user?.role === 1 ? (
            <MailboxAdmin
              setOpenModal={openModal}
              herLaden={refreshMail}
              onConversationOpen={handleConversationOpen}
              mobileChatOpen={mobileChatOpen}
            />
          ) : (
            <MailboxKlant
              setOpenModal={openModal}
              herLaden={refreshMail}
              onConversationOpen={handleConversationOpen}
              mobileChatOpen={mobileChatOpen}
            />
          )}
          <MailList
            setOpen={setOpenDialog}
            mobileChatOpen={mobileChatOpen}
            onExitMobileChat={handleExitMobileChat}
          />
        </main>
      </div>
      <RPDrawerMessaging open={openDialog} setOpen={setOpenDialog} />
    </div>
  );
};

export default MailBox;
